import { createSelector } from 'reselect';
import { persistFiltersOnSearchSelector } from 'selectors/testTarget/offers/persistFiltersOnSearch/persistFiltersOnSearchSelector';

const enabledSelector = createSelector(persistFiltersOnSearchSelector, persistFiltersOnSearch => !!persistFiltersOnSearch.enabled);

export { enabledSelector };
